package nl.volleyplanner.extensions

import kotlinx.coroutines.CoroutineName
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.isActive

val CoroutineScope.name: String
    get() = (coroutineContext[CoroutineName]?.name ?: "unnamed")
        .let { name -> if (isActive) name else "$name (cancelled)" }
